import { render, staticRenderFns } from "./Lucky.vue?vue&type=template&id=6f8dd945&scoped=true"
import script from "./Lucky.vue?vue&type=script&lang=js"
export * from "./Lucky.vue?vue&type=script&lang=js"
import style0 from "./Lucky.vue?vue&type=style&index=0&id=6f8dd945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8dd945",
  null
  
)

export default component.exports